import React, { useState, useRef, useEffect, useCallback } from 'react';
import {
  Button,
  Modal,
  Input,
  ModalHeader,
  ModalBody,
  ModalFooter,
  InputGroup,
  InputGroupAddon,
} from 'reactstrap';
import { useMutation } from 'react-fetching-library';
import { useQueryClient } from 'react-query';
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { requestTemplate } from "../api/actions/templates";

import useFileUpload from "../api/hooks/useFileUpload";
import { useProfile } from "../api/hooks/profile";
import { useRequestCustomTemplate } from "../api/hooks/templates";

import { getFileSize, noop } from '../utils';

import LoadingButton from './LoadingButton';
import DragZone from './DragZone';

function RequestTemplateModal({ defaultIsOpen, onSuccess = noop }) {
  const { t } = useTranslation(['common', 'template-catalog'])
  const [isOpen, setIsOpen] = useState(defaultIsOpen);
  const [files, setFiles] = useState([]);
  const { profile } = useProfile()
  const { mutate: requestCustomTemplateMutate, isLoading: isRequestingTemplate } = useRequestCustomTemplate({
    onSuccess: (data) => {
      setFiles([])
      setIsOpen(false)
      onSuccess(data)
    }
  })
 
  const { uploadFile, uploadFileState  } = useFileUpload({
    onSuccess: ({ url, BaseFileName, fileId }) => {
      requestCustomTemplateMutate({
        name: BaseFileName,
        type: 'starter',
        url,
      })
    }
  })
 
  const toggleModal = () => {
      if (!isRequestingTemplate) {//
          setFiles([])
          setIsOpen(isOpen => !isOpen)
      }
    }

  const handleDrop = useCallback((acceptedFiles) => {
    setFiles(acceptedFiles.map(file => {
      const fileSize = getFileSize(file.size);
      
      return Object.assign(file, {
        fileSize: `${fileSize.amount.toFixed(2)} ${fileSize.type}`
      })
    }))
  }, [])

  const handleSubmit = () => {
    if (profile?.templates?.remaining > 0) {
      uploadFile({file: files[0] })
    } else {
      toast.error(t('common:errors.NotAvailableTemplateRequests'))
    }
  }

  return (
    <>
    <Button color="accent-100" size="sm" onClick={toggleModal}>Solicitar Plantilla</Button>
    <Modal isOpen={isOpen} toggle={toggleModal} centered>
      <ModalHeader className="position-relative text-center py-3">
          {t('actions.requestTemplate')}

          {/* <div className="position-absolute right-0" style={{ right: 10, top: 0}} onClick={toglge}>
              X
          </div> */}
      </ModalHeader>
      <ModalBody className="modal-height">
        <div className="text-center mb-2">
          <p className="font-weight-bold mb-1">Arrastra el archivo a cargar para crear tu plantilla</p>
          <p className="font-weight-bold">Tu archivo deberá estar formato PDF o Word</p>
          <div className="p-2">
            <FontAwesomeIcon className="text-accent" icon="file-alt" size="3x" />
          </div>
        </div>
        {
            files?.map(file => (
              <div className="d-flex mb-1 mr-1 align-items-center justify-content rounded p-3 bg-grey" key={file.name}>
                <FontAwesomeIcon className="color-accent" icon='file' size="2x" />
                <div className="d-flex flex-column ml-3">
                  <span>{file.name}</span>
                  <span className="text-muted">{file.fileSize}</span>
                </div>
              </div>
            ))
          }
      
      {
        !files?.length &&
      
          <DragZone
              multiple={false}
              // imgSrc="/images/listing/createDocument/subir.svg"
              label={t('Arrastra y suelta tu archivo o haz clic para cargar')}
              className="frontdesk-drag bg-indigo-10"
              acceptedFiles={["application/pdf", "application/msword", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"]}
              // noClick={() => { }}
              version={2}
              icon="cloud-upload-alt"
              // handleFile={onDrop}
              onDrop={handleDrop}
          />
        }
        <div className="text-muted text-left mt-4 font-size-9">{t('template-catalog:requestTemplateDisclaimer')}</div>

      </ModalBody>
      <ModalFooter>
        <div className="mx-auto">
          <Button color="accent" onClick={toggleModal}>{t('actions.close')}</Button>
          <LoadingButton 
            className="ml-2" 
            color="accent-100" 
            onClick={handleSubmit} 
            loading={uploadFileState.isLoading || isRequestingTemplate} 
            loadingText={t('actions.uploading')}
            disabled={files?.length < 1}
          >
            {t('actions.upload')}
          </LoadingButton>
        </div>  
      </ModalFooter>
  </Modal>
  </>
  )
}

export default RequestTemplateModal;